// import axios from 'axios'
// Notification

export default function useKhachHangList() {
  const treeConfig = { nodeWidth: 220, nodeHeight: 80, levelHeight: 100 }
  return {
    treeConfig,
  }
}
